import { render, staticRenderFns } from "./IndexOrderItem.vue?vue&type=template&id=4f749d43&scoped=true&"
import script from "./IndexOrderItem.vue?vue&type=script&lang=js&"
export * from "./IndexOrderItem.vue?vue&type=script&lang=js&"
import style0 from "./IndexOrderItem.vue?vue&type=style&index=0&id=4f749d43&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f749d43",
  null
  
)

export default component.exports